import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieNotice from "@/components/CookieNotice";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import OurBrands from "@/pages/OurBrands";
import TheApartment from "@/pages/TheApartment";
import ThingsToDo from "@/pages/ThingsToDo";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-brands" element={<OurBrands />} />
          <Route path="/the-apartment" element={<TheApartment />} />
          <Route path="/things-to-do-nearby" element={<ThingsToDo />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <CookieNotice />
      </BrowserRouter>
    </div>
  );
}

export default App;
